import * as React from 'react';
import cn from 'classnames';
import _ from 'lodash';

import Table, { RowData } from '../../components/table/Table';
import { WaiverWorkItemView } from '../../types/waiverWorkItem';

type Props = {
  fieldMap: { [key: string]: (workItem: WaiverWorkItemView) => any },
  waiverWorkItemViews?: WaiverWorkItemView[],
  errorMsg?: string,
  navigateTo: (path: string) => void,
  loading?: boolean,
};

export const DefaultFieldMap: { [key: string]: (workItem: WaiverWorkItemView) => any } = {
  'Airline Code': workItem => workItem.airlineCode,
  'Issue Date/Time': workItem =>
    (workItem.createdAt && workItem.createdAt.fromNow()) || '',
  'Notification ID': workItem => workItem.changeEventId,
  'Notification Source': workItem => workItem.source,
  'Last Changed By': workItem =>
    workItem.lastChangedByUserName || workItem.lastChangedByUserId,
  'Waivers Associated': workItem =>
    _(workItem.associatedWaivers)
      .map(waiver => (
        <a key={waiver.id} href={`/waivers/${waiver.id}`}>
          {waiver.name}
        </a>
      ))
      .reduce((acc, curr) => (!acc.length ? [curr] : [...acc, ', ', curr]), [] as (string | JSX.Element)[]),
};

class WaiverListComponent extends React.Component<Props> {
  static defaultProps = {
    fieldMap: DefaultFieldMap,
  };

  getTableData(): RowData[] {
    const { waiverWorkItemViews, fieldMap } = this.props;

    if (!waiverWorkItemViews) {
      return [];
    }

    return waiverWorkItemViews.map((waiverWorkItemView: WaiverWorkItemView) => {
      const workItemLocation = `/waivers/workItem/${waiverWorkItemView.id.toString()}`;

      return {
        key: waiverWorkItemView.id.toString(),
        linkTo: workItemLocation,
        values: _(fieldMap)
          .values()
          .map(valueFunction => valueFunction(waiverWorkItemView))
          .value(),
      };
    });
  }

  render() {
    const data = this.getTableData();
    const headers = _(this.props.fieldMap)
      .keys()
      .value()
      .map(value => {
        return { header: value };
      });

    const noRowsMessage = 'No Waiver Action Items';

    const message = this.props.errorMsg ? 'Error loading values' : undefined;

    return (
      <>
        <div className={cn('table-responsive')}>
          <Table
            {...{
              headers,
              data,
              noRowsValue: noRowsMessage,
              message,
              loading: this.props.loading,
            }}
          />
        </div>
      </>
    );
  }
}

export default WaiverListComponent;
